'use client'

import CopylightFooter from "./copylight_footer";
import MessageFooter from "./message_footer";
import css from "./footer.module.scss"

export default function Footer(){
    return (
        <footer className={css.footer}>
            <div className={css.version}>v1.1.3-slideFixed3</div>
            {/* <MessageFooter />
            <CopylightFooter /> */}
        </footer>
    )
}